import React, { useEffect, useState, useRef } from 'react'
import { signupForOrganizationWithUser, getAllTempOrganizations } from '../apis/apiList/organizationApi';
import { useMessage } from '../context/MessageContext';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import headerLogo from "../assets/images/landing-header.png";
import axios from 'axios';
import ExampleVideos from '../components/firstFifty/ExampleVideos';
import '../css/videoDemoSignupCss/demoSignupStyle.css';

function SignupPage() {
    const orgRef = useRef(null);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        // phone: "",
        organization: "",
        selectedTempOrgId: null,
        selectedOrgSnapshotId: null,
    });

    const { showMessage } = useMessage();

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [orgSuggestions, setOrgSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suppressSuggestions, setSuppressSuggestions] = useState(false);
    const [loading, setLoading] = useState(false);
    const [orgList, setOrgList] = useState([]);

    useEffect(() => {
        const inputs = document.querySelectorAll(".contact-form .entry input");
        console.log('inputs', inputs);
        const handleFocus = (e) => {
            console.log('handleFocus', e.target.closest(".entry"));
            e.target.closest(".entry")?.classList.add("input_focus");
        };

        const handleBlur = (e) => {
            e.target.closest(".entry")?.classList.remove("input_focus");
        };

        const handleInput = (e) => {
            const entry = e.target.closest(".entry");
            if (e.target.value !== "") {
                entry?.classList.add("value_focus");
            } else {
                entry?.classList.remove("value_focus");
            }
        };

        inputs.forEach((input) => {
            input.addEventListener("focus", handleFocus);
            input.addEventListener("blur", handleBlur);
            input.addEventListener("input", handleInput);
        });

        // Cleanup event listeners when component unmounts
        return () => {
            inputs.forEach((input) => {
                input.removeEventListener("focus", handleFocus);
                input.removeEventListener("blur", handleBlur);
                input.removeEventListener("input", handleInput);
            });
        };
    }, []);

    const validate = () => {
        const newErrors = {};

        if (!formData.firstName.trim()) {
            newErrors.firstName = "First Name is required.";
        }
        if (!formData.lastName.trim()) {
            newErrors.lastName = "Last Name is required.";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = "Invalid email format.";
        }

        // if (!formData.phone.trim()) {
        //     newErrors.phone = "Phone is required.";
        // } else if (!/^\d{10}$/.test(formData.phone)) {
        //     newErrors.phone = "Phone must be 10 digits.";
        // }

        if (!formData.organization.trim()) {
            newErrors.organization = "Organization is required.";
        }

        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            let updated = { ...prev, [name]: value };

            // Reset selectedTempOrgId if user edits organization name manually
            if (name == "organization") {
                console.log('updated', updated);
                updated.selectedTempOrgId = null;
                updated.selectedOrgSnapshotId = null;
            }

            return updated;
        });
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            try {
                setLoading(true);
                const response = await signupForOrganizationWithUser(formData);
                showMessage(response.message, 'success')
                // navigate('/')
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    organization: "",
                    selectedTempOrgId: null,
                    selectedOrgSnapshotId: null,
                })

                setErrors({});
                const entries = document.querySelectorAll(".contact-form .entry");
                entries.forEach((entry) => {
                    entry.classList.remove("input_focus");
                    entry.classList.remove("value_focus");
                });
            } catch (error) {
                console.error('Error submitting form:', error);
                showMessage(error?.response?.data?.message, 'error')
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (suppressSuggestions) {
            setSuppressSuggestions(false); // reset for future changes
            return;
        }
        const delayDebounceFn = setTimeout(async () => {
            const query = formData.organization.trim();
            if (query.length > 1) {
                // axios
                //     .get(`${process.env.REACT_APP_VPMA_BACKEND_URL}/snapshotvideos/get/identical/organization/${query}`)
                //     .then((response) => {
                //         console.log('response', response)
                //         setOrgSuggestions(response.data?.organizations || []); // Adjust if API response format is different
                //         setShowSuggestions(true);
                //     })
                //     .catch((error) => {
                //         console.error("Error fetching organization suggestions:", error);
                //         setOrgSuggestions([]);
                //         setShowSuggestions(false);
                //     });

                try {
                    const response = await getAllTempOrganizations(query);
                    console.log('org', response);
                    setOrgSuggestions(response?.data || []);
                    setShowSuggestions(true);
                } catch (error) {
                    console.error("Error fetching organization suggestions:", error);
                    setOrgSuggestions([]);
                    setShowSuggestions(false);
                }
            } else {
                setOrgSuggestions([]);
                setShowSuggestions(false);
            }
        }, 300); // Debounce for 300ms

        return () => clearTimeout(delayDebounceFn);
    }, [formData.organization]);

    // useEffect(() => {
    //     if (suppressSuggestions) {
    //         setSuppressSuggestions(false); // reset for future changes
    //         return;
    //     }
    //     const delayDebounceFn = setTimeout(() => {
    //         const query = formData.organization.trim();
    //         if (query.length > 1) {
    //             axios
    //                 .get(`${process.env.REACT_APP_VPMA_BACKEND_URL}/snapshotvideos/get/identical/organization/${query}`)
    //                 .then((response) => {
    //                     console.log('response', response)
    //                     setOrgSuggestions(response.data?.organizations || []); // Adjust if API response format is different
    //                     setShowSuggestions(true);
    //                 })
    //                 .catch((error) => {
    //                     console.error("Error fetching organization suggestions:", error);
    //                     setOrgSuggestions([]);
    //                     setShowSuggestions(false);
    //                 });
    //         } else {
    //             setOrgSuggestions([]);
    //             setShowSuggestions(false);
    //         }
    //     }, 300); // Debounce for 300ms

    //     return () => clearTimeout(delayDebounceFn);
    // }, [formData.organization]);

    const handleSelectSuggestion = (org) => {
        setFormData((prev) => ({
            ...prev,
            organization: org.organizationName,
            selectedTempOrgId: org._id,
            selectedOrgSnapshotId: org?.organizationId,
            // selectedOrgSnapshotId: org?.snapShotVideoOrgId,
        }));
        setSuppressSuggestions(true);
        setShowSuggestions(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (orgRef.current && !orgRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
  return (
    <Box className="signup-page">
        <header id="header" class="landing-header free-video-header">
            <div class="row ">
                <div class="header-section ">
                    <div class="container">
                        <div class="header-wrap ">
                            <h1>
                                Get a Free <span className="red">Snapshot Video</span>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        {/* <header className='demo-signup-header'>
            <div className="title wow zoomIn">
                <h2>
                    Get a Free <span className="red">Snapshot Video</span>
                </h2>
            </div>
        </header> */}
        <main className='demo-video-signup-main'>
            <section className="signup reserve-your-spot" id="demo-video-signup">
                <div className="row ">
                    <div className="container">
                        <div className="reserve-content-wrap">
                            <div className="contact-form wow zoomIn" style={{ border: "1px solid #d5d5d5", marginTop: "20px"}}>
                                <form
                                    className="from-ct"
                                    id="contact-enquiryform"
                                    onSubmit={handleSubmit}
                                >
                                    <div className="ct-form-field-warps">
                                        <div className='signup-fname-lname'>
                                            <div className="fields-wrap sf-name-wrap">
                                                <div className="entry input-wrap">
                                                    <label htmlFor="firstName">
                                                        First Name<span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="firstName"
                                                        name="firstName"
                                                        className="form-control form-booking"
                                                        value={formData.firstName}
                                                        onChange={handleChange}
                                                    />
                                                    {errors.firstName && (
                                                        <small style={{ color: "red" }}>{errors.firstName}</small>
                                                    )}
                                                </div>
                                            </div>
                                            
                                            <div className="fields-wrap sf-name-wrap">
                                                <div className="entry input-wrap">
                                                    <label htmlFor="lastName">
                                                        Last Name<span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="lastName"
                                                        name="lastName"
                                                        className="form-control form-booking"
                                                        value={formData.lastName}
                                                        onChange={handleChange}
                                                    />
                                                    {errors.lastName && (
                                                        <small style={{ color: "red" }}>{errors.lastName}</small>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="fields-wrap sf-email-wrap">
                                            <div className="entry input-wrap">
                                                <label htmlFor="email">
                                                    Email<span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    className="form-control form-booking"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                                {errors.email && (
                                                    <small style={{ color: "red" }}>{errors.email}</small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="fields-wrap sf-number-wrap">
                                            <div className="entry input-wrap" style={{ position: "relative" }} ref={orgRef}>
                                                <label htmlFor="Organization">
                                                    Organization<span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="Organization"
                                                    name="organization"
                                                    className="form-control form-booking"
                                                    value={formData.organization}
                                                    onChange={handleChange}
                                                />
                                                {showSuggestions && orgSuggestions.length > 0 && (
                                                    <ul className="suggestions-list">
                                                        {orgSuggestions.map((org, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => handleSelectSuggestion(org)}
                                                                className="suggestion-item"
                                                            >
                                                                {/* {org.organization_name} */}
                                                                {org.organizationName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                {errors.organization && (
                                                    <small style={{ color: "red" }}>
                                                    {errors.organization}
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        {/* <div className="fields-wrap sf-message-wrap">
                                            <div className="entry input-wrap">
                                                <label htmlFor="phone">
                                                    Phone<span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="phone"
                                                    name="phone"
                                                    className="form-control form-booking"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                />
                                                {errors.phone && (
                                                    <small style={{ color: "red" }}>{errors.phone}</small>
                                                )}
                                            </div>
                                        </div> */}

                                    </div>

                                    <div className="google-submit enquiry-button-wrapper btn order-btn">
                                        <input
                                            type="submit"
                                            value={loading ? "Submitting..." : "Sign Up"}
                                            className="csubmit-btn1 f-submit"
                                            name="btnsubmit1"
                                            disabled={loading}
                                        />
                                        {/* {loading && (
                                            <div className="ajaxLoader">
                                                <img alt="loading" src="./images/loader.gif" />
                                            </div>
                                        )} */}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ExampleVideos />
        </main>
        
        {/* <!--footer--> */}
        <footer id="footer" class="landing-footer">
          <div class="row">
            <div class="container">
              <div class="copyright-container-wrap">
                <p>
                  {" "}
                  © 2025 <a href="Landing.html"> Snapshot Videos </a> - All
                  Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </footer>
    </Box>
  );
}

export default SignupPage